import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import featuresApi from '../api/featuresApi';

// Async thunk для загрузки features
export const fetchUserFeatures = createAsyncThunk(
    'features/fetchUserFeatures',
    async ({ userId, email }, { rejectWithValue }) => {
        try {
            const response = await featuresApi.getUserFeatures(userId, email);
            //console.log("features", response)
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Ошибка загрузки');
        }
    }
);

const initialState = {
    hasSubscription: false,
    planType: null,        // 'pro', 'standard', 'legacy'
    planName: null,
    endDate: null,
    isLegacy: false,
    isUnlimited: false,
    features: null,
    // {
    //     chatTypes: [],
    //     voiceAssistant: false,
    //     storage: false,
    //     maxDevices: 0
    // }
    loading: false,
    error: null,
    loaded: false,
};

const featuresSlice = createSlice({
    name: 'features',
    initialState,
    reducers: {
        clearFeatures: (state) => {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserFeatures.pending, (state) => {
                state.loading = true;
                state.error = null;
                //console.log('[Features] Loading...');
            })
            .addCase(fetchUserFeatures.fulfilled, (state, action) => {
                //console.log('[Features] Loaded:', action.payload);
                state.loading = false;
                state.loaded = true;
                state.hasSubscription = action.payload.hasSubscription || false;
                state.planType = action.payload.planType || null;
                state.planName = action.payload.planName || null;
                state.endDate = action.payload.endDate || null;
                state.isLegacy = action.payload.isLegacy || false;
                state.isUnlimited = action.payload.isUnlimited || false;
                state.features = action.payload.features || null;
            })
            .addCase(fetchUserFeatures.rejected, (state, action) => {
                console.error('[Features] Error:', action.payload);
                state.loading = false;
                state.error = action.payload;
                state.loaded = true;
            });
    },
});

export const { clearFeatures } = featuresSlice.actions;

// Селекторы
export const selectHasSubscription = (state) => state.features.hasSubscription;
export const selectPlanType = (state) => state.features.planType;
export const selectPlanName = (state) => state.features.planName;
export const selectEndDate = (state) => state.features.endDate;
export const selectIsLegacy = (state) => state.features.isLegacy;
export const selectIsUnlimited = (state) => state.features.isUnlimited;
export const selectFeatures = (state) => state.features.features;
export const selectFeaturesLoading = (state) => state.features.loading;
export const selectFeaturesLoaded = (state) => state.features.loaded;

export default featuresSlice.reducer;
